import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{! RESPONSIBLE TEAM: team-inbox-management }}\n{{outlet}}",{ moduleName: "embercom/templates/inbox.hbs" })